import { FunctionComponent, useEffect, useState } from 'react';
import { commitMutation } from 'react-relay';
import { Redirect, usePathParam } from 'react-resource-router';
import { GetExistingOrNewProfileFromKhorosUserIdMutation } from 'graphql/__generated__/GetExistingOrNewProfileFromKhorosUserIdMutation.graphql';
import { GET_EXISTING_OR_NEW_PROFILE_FOR_KHOROS } from 'graphql/GetExistingOrNewProfileFromKhorosUserId';
import { environment } from 'services/relay';
import Loader from 'components/common/loader/Loader';
import { KhorosUppProfile } from 'constants/types';

const connectKhorosUserToUpp = (
  khorosUserId: string,
): Promise<KhorosUppProfile | null> => {
  return new Promise((resolve, reject) => {
    commitMutation<GetExistingOrNewProfileFromKhorosUserIdMutation>(
      environment,
      {
        mutation: GET_EXISTING_OR_NEW_PROFILE_FOR_KHOROS,
        variables: {
          khorosUserId,
        },
        onCompleted: (response, errors) => {
          const getProfileFromKhoros =
            response?.unified?.profile?.getExistingOrNewProfileFromKhorosUserId;

          if (getProfileFromKhoros?.success === false || errors) {
            let errorCode = 'generic_error';
            if (errors) {
              console.error(
                'Fetching profile for khoros user id failed',
                errors,
              );
            } else {
              errorCode =
                getProfileFromKhoros?.errors?.[0]?.code || 'generic_error';
            }
            reject({
              errorCode,
            });
          } else {
            resolve(getProfileFromKhoros?.unifiedProfile ?? null);
          }
        },
        onError: (error) => {
          console.error('Fetching profile for khoros user id failed', error);
          reject({
            errorCode: 'generic_error',
          });
        },
      },
    );
  });
};

const Connect: FunctionComponent = () => {
  const [appname] = usePathParam('appname');
  const [khorosUserId] = usePathParam('id');
  const [responseStatus, setResponseStatus] = useState<null | boolean>(null);
  const [internalId, setInternalId] = useState<string | null>(null);

  if (appname !== 'forums' || !khorosUserId) {
    return <Redirect to={'/error/invalid_path'} />;
  }

  useEffect(() => {
    (async () => {
      try {
        const khorosUserUppProfile = await connectKhorosUserToUpp(khorosUserId);
        const internalId = khorosUserUppProfile?.internalId;
        if (internalId) {
          setInternalId(internalId);
          setResponseStatus(true);
        }
      } catch (e: any) {
        setResponseStatus(false);
      }
    })();
  }, []);

  if (responseStatus === null) {
    return <Loader />;
  } else if (responseStatus === true && internalId) {
    return <Redirect to={`/profile/${internalId}`} />;
  } else {
    return <Redirect to={'/error/invalid_path'} />;
  }
};

export default Connect;
